import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Clock, Users } from "lucide-react";

export default function ExperienceCard({ exp, featured = false, index = 0, imageOverride, altOverride, waiting = false }) {
  const src = imageOverride || null; // stock fallback removed – neutral placeholder when no admin image
  const alt = altOverride || exp.title;
  return (
    <article
      data-testid={`experience-card-${exp.slug}`}
      className={`group relative overflow-hidden bg-ivory border border-charcoal/10 hover:border-burgundy/40 transition-colors ${featured ? "md:row-span-2" : ""}`}
    >
      <Link to={`/zazitky/${exp.slug}`} className="block h-full">
        <div className={`relative overflow-hidden ${featured ? "aspect-[4/5] md:aspect-[4/6]" : "aspect-[4/3]"} bg-cream`}>
          {src ? (
            <img
              src={src}
              alt={alt}
              loading={index > 2 ? "lazy" : "eager"}
              className="w-full h-full object-cover transition-transform duration-[900ms] group-hover:scale-[1.04]"
            />
          ) : (
            <div className="w-full h-full" aria-hidden="true" />
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-charcoal/50 via-transparent to-transparent" />
          {exp.featured && (
            <span className="absolute top-4 left-4 bg-ivory/90 text-burgundy text-[10px] tracking-[.22em] uppercase px-3 py-1">
              Doporučujeme
            </span>
          )}
        </div>
        <div className="p-6 md:p-7">
          <h3 className={`font-serif ${featured ? "text-2xl md:text-3xl" : "text-xl md:text-2xl"} text-charcoal leading-tight`}>
            {exp.title}
          </h3>
          <p className="mt-3 text-sm text-charcoal/70 leading-relaxed line-clamp-3">{exp.short}</p>

          <div className="mt-5 flex flex-wrap gap-x-5 gap-y-2 text-xs text-charcoal/60">
            <span className="inline-flex items-center gap-1.5"><Clock size={13} className="text-gold" /> {exp.duration}</span>
            <span className="inline-flex items-center gap-1.5"><Users size={13} className="text-gold" /> {exp.audience}</span>
          </div>

          <div className="mt-6 flex items-end justify-between gap-4">
            <div>
              <div className="text-[10px] tracking-[.22em] uppercase text-charcoal/50">Cena</div>
              <div className="font-serif text-lg text-burgundy">{exp.price}</div>
            </div>
            <span className="inline-flex items-center gap-1 text-sm text-charcoal group-hover:text-burgundy transition-colors">
              {exp.cta} <ArrowUpRight size={16} />
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}
